window.subscriptionFlow = {
  productType : 'platecrate',
  productSize : null,
  age: null,
  positon : null,
  frequency : 'monthly',
  shipFrequency : null,
  giftVariantId :null,
  giftNote :"",
  payFrequency: null,
  subTotal : null,
  crateName: null,
  crateSKU:null,
  variantId:null,
  addItems: [],
  addToCartBtn:null,
  selling_plan_id: null,
  start_date:'',
  end_date:'',
  discount_code:'',
  discount_amount:'',
  discount_type:'',
  per_crate_price:'',
  total: null,
  productPropertyNote:"",
  isProductFound: false
}
class subscriptionFunnalCommon {
  constructor(){
      this.isAllDetailSelected();

   
        let interval = setInterval(() => {
        var size_cookie = Utility.getCookie('size_cookie');
    
        if(size_cookie == '' || size_cookie == undefined)
        {}else{
         
       //    document.querySelector("[data_size_dropdown]").value = size_cookie;
           const sizeInput = document.querySelector(`[data_size_dropdown="${size_cookie}"]`);
           if (sizeInput) {
             sizeInput.dispatchEvent(new Event('change'));
           }

          const targetRadio = document.querySelector(`input[data_size_dropdown][value="${size_cookie}"]`);
       
          if (targetRadio) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }

        }
        
        var age_cookie = Utility.getCookie('age_cookie');
        if(age_cookie == '' || age_cookie == undefined)
        {}else{
          if (document.querySelector("[data_age_dropdown]")) {
            
          
          document.querySelector("[data_age_dropdown]").value = age_cookie;
          document.querySelector("[data_age_dropdown]").dispatchEvent(new Event('change'));
          }
        }

        var position_cookie = Utility.getCookie('position_cookie');
        if(position_cookie == '' || position_cookie == undefined)
        {}else{
          if (document.querySelector("[data_position_dropdown]")) {
            
          
          document.querySelector("[data_position_dropdown]").value = position_cookie;
          document.querySelector("[data_position_dropdown]").dispatchEvent(new Event('change'));
          }
        }
        clearInterval(interval);
      }, 1000)
    

  // select size dropdown
   if (document.querySelectorAll("[data_size_dropdown]").length > 0 ) {
      // document.querySelector("[data_size_dropdown]").addEventListener("change",(event)=>{
      //   this._sizeDropDown(event);
      //   this.isAllDetailSelected();
      // });
      document.querySelectorAll("[data_size_dropdown]").forEach((radio) => {
        radio.addEventListener("change", (event) => {
          this._sizeDropDown(event);
          this.isAllDetailSelected();
        });
      });
   };


  // select age dropdwon
  if (document.querySelectorAll("[data_age_dropdown]").length > 0 ) {
    document.querySelector("[data_age_dropdown]").addEventListener("change",(event)=>{
      this._sizeAgeDown(event);
      this.isAllDetailSelected();
    });
  }
  // select size dropdwon
  if (document.querySelectorAll("[data_position_dropdown]").length > 0 ) {
    document.querySelector("[data_position_dropdown]").addEventListener("change",(event)=>{
      this._positionDropDown(event);
      this.isAllDetailSelected();
    });
  }

     //4th tab choose crate
   document.querySelectorAll("[data-first-crate-checkbox]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
        if (window.subscriptionFlow.productSize != null) {
            let currentEle = event.currentTarget;
            this._selectCrate(currentEle);
        }
    
      this.isAllDetailSelected();
    })
  });

   //4th tab choose crate
   // document.querySelectorAll("[data-first-crate-checkbox]").forEach(ele=>{
   //    ele.addEventListener("click",(event)=>{
   //        if (window.subscriptionFlow.productSize != null) {
   //            const selectBoxOptions = event.target.closest('.firstcrate-block-inner').querySelectorAll('.box-sku-dropdown option');
   //            const selectedOption = Array.from(selectBoxOptions).find((option) => window.subscriptionFlow.productSize === option.dataset.variantTitle);
   //            let isAvailable = selectedOption?.dataset.available || "";
              
              
   //            let stepCard = event.target.closest('.step-card');
   //            let submitSubscriptionBtn = stepCard.querySelector('[data-next-flow-btn] [data-submit-subscription]');

   //            isAvailable !== 'false' ? submitSubscriptionBtn.removeAttribute('disabled') : submitSubscriptionBtn.setAttribute('disabled','disabled');

   //            submitSubscriptionBtn.innerText = isAvailable !== 'false' ? 'BRING IT HOME' : 'SOLDOUT';

   //            let currentEle = event.currentTarget;
   //            this._selectCrate(currentEle);
   //        }
      
   //      this.isAllDetailSelected();
   //    })
   //  });

  
 //add subscription product
  document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      window.subscriptionFlow.addToCartBtn = event.currentTarget;
      window.subscriptionFlow.addToCartBtn.classList.add('loading');
      this._AddToCart(event);
    });
  });

  this.checkSelectedOptions()
} 
checkSelectedOptions(){

  setTimeout(() => {
    

  const selectedRadio = document.querySelector('[data-subscription-type]:checked');

if(selectedRadio){

  window.subscriptionFlow.productType = selectedRadio.getAttribute("product_type");
  const select = document.querySelector('[data-sub-ship-frequency]');
  if(select){
  select.value = "1"; // optional, only if you want to ensure it's selected
  select.dispatchEvent(new Event('change', { bubbles: true }));
  }

}
}, 1000);

}

  _sizeDropDown(event){
    let currentEle = event.currentTarget;
   
    window.subscriptionFlow.productSize = currentEle.value;
    if (window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test') {
      document.cookie = `size_cookie=${currentEle.value};expires=30;path=/`;
      subscriptionFunnel.prototype._setCrateInfo();
    } 
    if(window.globalVariables.templateSuffix == 'subscription-product'){
      if(window.subscriptionFlow.shipFrequency != null){
          document.querySelectorAll("[data-pay-checkobox]").forEach(ele=>{
              if(ele.checked){
                  let parentEle = ele.closest("[main_product_id]");
                  this.setVariantDetails(parentEle);
              }
          })
      };
      document.querySelectorAll("[data-first-crate-checkbox]").forEach(element=>{
          if (element.checked) {
              this._selectCrate(element);
          }
      })
    }
    if (window.globalVariables.templateSuffix === "subscription"){
      if(window.subscriptionFlow.shipFrequency != null){
        document.querySelectorAll("[data-pay-checkobox]").forEach(ele=>{
          if(ele.checked){
            let parentEle = ele.closest("[main_product_id]");
            this.setVariantDetails(parentEle);
            this._pdpSelectCrate();
          }
        })
      };
      this.setProCrateSKU()
    }

  }
  setProCrateSKU(){
    let shortNameForSize;
    if (window.subscriptionFlow.productSize){
      shortNameForSize = window.subscriptionFlow.productSize;
      shortNameForSize = shortNameForSize.match(/\b(\w)/g); // ['J','S','O','N']
      shortNameForSize = shortNameForSize.join(''); // JSON
      if (shortNameForSize == 'YX') {
        shortNameForSize = "YXL"
      }
      if (window.subscriptionFlow.productSize == 'Adult XXL') {
        shortNameForSize = 'XXL'
      }else if(window.subscriptionFlow.productSize == 'Adult XL') {
        shortNameForSize = 'XL'
      }
      if(window.subscriptionFlow.productType === "platecrate"){
        const classicCrateInput = document.querySelector('input[data-ClassicCrate]');
        if (classicCrateInput){
          const proCrateValue = classicCrateInput.value;
          window.subscriptionFlow.crateSKU =`${proCrateValue}-${shortNameForSize}`;
        }
      }else{
        const proCrateInput = document.querySelector('input[data-proCrate]');
        if (proCrateInput) {
          const proCrateValue = proCrateInput.value;
          window.subscriptionFlow.crateSKU = `${proCrateValue}-${shortNameForSize}`;
        }
      }
    }
  }

  _sizeAgeDown(event){
    let currentEle = event.currentTarget;
    const raw = currentEle.value;
    window.subscriptionFlow.age = raw === '' || raw == null ? null : raw;
    if (window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test') {
      document.cookie = `age_cookie=${raw};expires=30;path=/`;
      subscriptionFunnel.prototype._setCrateInfo();
    }  
  }

  _positionDropDown(event){
  let currentEle = event.currentTarget;
  const raw = currentEle.value;
  window.subscriptionFlow.positon = raw === '' || raw == null ? null : raw;
  if (window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test' ) {
    document.cookie = `position_cookie=${raw};expires=30;path=/`;
      subscriptionFunnel.prototype._setCrateInfo();
  }  

  }

setVariantDetails(ele){
  let mainProductData = JSON.parse(ele.querySelector("[data-main-product-variant]").innerText);
  
  
  mainProductData = mainProductData.find(x=> x.variant_title ==window.subscriptionFlow.productSize);
  if(!mainProductData){
    document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
      ele.classList.add("disabled");
      ele.querySelector(".add-text").innerText = 'Sold Out';
    });
   
    window.subscriptionFlow.isProductFound = false;
  }else{
 
  // window.subscriptionFlow.variantId = parseInt(mainProductData.subscription_varint_id);
  window.subscriptionFlow.variantId = parseInt(mainProductData.variant_id); 
   window.subscriptionFlow.selling_plan_id = parseInt(mainProductData.selling_plan_id); 
   window.subscriptionFlow.discount_amount = mainProductData.discount_amount;
   window.subscriptionFlow.discount_code = mainProductData.discount_code;
   window.subscriptionFlow.start_date = mainProductData.start_date;
   window.subscriptionFlow.end_date = mainProductData.end_date;
   window.subscriptionFlow.per_crate_price =mainProductData.per_crate_price;
   window.subscriptionFlow.discount_type = mainProductData.discount_Type;

   document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
    ele.classList.remove("disabled");
    ele.querySelector(".add-text").innerText = 'Bring It Home';
  });
  window.subscriptionFlow.isProductFound = true;
  }
};

//4th step select crate
_selectCrate(ele){
  let shortNameForSize;
  let currentEle = ele;
  let parentEle = currentEle.closest("[data-first-crate-wrap]");
  parentEle.querySelector("[data-first-crate-checkbox]").checked = true;
  let is_crate_soldout = parentEle.getAttribute("data-is-crate-available");
  let is_hidden_crate = parentEle.classList.contains("d-none");

  if (is_crate_soldout == false || is_crate_soldout == 'false' || is_hidden_crate == true) {
    document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
      ele.classList.remove("soldout");
      ele.querySelector(".add-text").innerHTML = `Bring It Home <span class="spinner"></span>`;
    });
  }else{
    document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
      ele.classList.add("soldout");
      ele.querySelector(".add-text").innerText = 'Sold Out';
    });
  }

  window.subscriptionFlow.crateName = parentEle.querySelector("[data_drate_name]").innerText;
  shortNameForSize = window.subscriptionFlow.productSize;
  shortNameForSize = shortNameForSize.match(/\b(\w)/g); // ['J','S','O','N']
  shortNameForSize = shortNameForSize.join(''); // JSON
  if (shortNameForSize == 'YX') {
    shortNameForSize = "YXL"
  }
   if (window.subscriptionFlow.productSize == 'Adult XXL') {
       shortNameForSize = 'AXXL'
    }else if(window.subscriptionFlow.productSize == 'Adult XL') {
      shortNameForSize = 'AXL'
   }
  let crateValue = parentEle.querySelector("[data-crate-value]").value;
  let crateEle = parentEle.querySelector("[data-crate-value]")
  if (window.subscriptionFlow.productType == "platecrate-pro") {
    if (parentEle.querySelectorAll("[data-crate-value]")[1]) {
      crateValue = parentEle.querySelectorAll("[data-crate-value]")[1].value;
      crateEle = parentEle.querySelectorAll("[data-crate-value]")[1];
      
    }
    
  }
  if (crateValue =='surprise') {
    window.subscriptionFlow.crateSKU = 'surprise'
  }else{
   const option = crateEle.querySelector(`select.box-sku-dropdown option[data-variant-title="${window.subscriptionFlow.productSize}"]`);
   
    if (option) {
      const sku = option.getAttribute('data-sku');
      if(option.getAttribute('data-available') == "true"){
        window.subscriptionFlow.crateSKU = sku;
        document.querySelectorAll("[data-next-flow-btn] [data-submit-subscription]").forEach(ele=>{
          ele.classList.remove("disabled");
          ele.querySelector(".add-text").innerText = 'Bring It Home';
        })
        window.subscriptionFlow.isProductFound = true;
      }else{
         document.querySelectorAll("[data-next-flow-btn] [data-submit-subscription]").forEach(ele=>{
          ele.classList.add("disabled");
          ele.querySelector(".add-text").innerText = 'Sold Out';
        })
        window.subscriptionFlow.isProductFound = false;
      }
   
    }else{
    window.subscriptionFlow.crateSKU =`${crateValue}-${shortNameForSize}`;
    window.subscriptionFlow.isProductFound = false;
    }
  }

  let cratedropdown = parentEle.querySelector("[data-crate-value]")
   // Get the selected index
   const selectedIndex = cratedropdown.selectedIndex;
  

   // Get the selected option using the index
   if (selectedIndex != undefined) {
    
    const selectedOption = Array.from(cratedropdown.options).find((option) => window.subscriptionFlow.productSize === option.dataset.variantTitle);
   let isAvailalble = selectedOption?.getAttribute("data-available");
  
   if (!selectedOption || isAvailalble !== 'true') {
    document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
      ele.classList.add("disabled", "soldout");
     ele.querySelector(".add-text").innerText = 'Sold Out';
    });
   }else{
    document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
      ele.classList.remove("soldout");
     ele.querySelector(".add-text").innerText = 'Bring It Home';
    });
   }
  }

  if (is_crate_soldout == false || is_crate_soldout == 'false' || is_hidden_crate == true) {
    window.subscriptionFlow.isProductFound = true;
  }else{
    window.subscriptionFlow.isProductFound = false;
  }
  
  if(window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test'){   subscriptionFunnel.prototype._setCrateInfo(); }
};

_pdpSelectCrate(){
  document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
    ele.classList.remove("soldout");
    ele.querySelector(".add-text").innerText = 'Bring It Home';
  });
}

async _AddToCart(event){
  if(window.globalVariables.cart.items.length > 0 && window.globalVariables.cart.total_price == 0){
    await this._clear_cart()
  }
  if (window.globalVariables.templateSuffix == 'subscription-product' && document.querySelectorAll("[data-first-crate-checkbox]").length > 0){
    document.querySelectorAll("[data-first-crate-checkbox]").forEach(element => {
      if (element.checked) {
        this._selectCrate(element);
      }
    })
}
  // if (window.subscriptionFlow.addToCartBtn != null) {
      if (window.subscriptionFlow.addToCartBtn) {
        const spinner = window.subscriptionFlow.addToCartBtn.querySelector(".spinner");
        if (spinner) {
          spinner.classList.remove("d-block");
        }
      }
  // }
  if (
    window.globalVariables.templateSuffix == 'subscription-flow' ||
    window.globalVariables.templateSuffix == 'subscription-flow-new-test' ||
    window.globalVariables.templateSuffix == 'subscription-product'
  ) {
    if (typeof ga === 'function') {
      const addToCartStep = window.globalVariables.templateSuffix == 'subscription-product' ? 'Single Page' : 'Step 5';
      ga('send', 'event', 'AddToCart', addToCartStep, 'Click on add to cart');
    }
  } 
  const items = []
   const giftPairId = `gift_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
   let giftProperty = {};
   giftProperty['_main_product_auto_renew_id']=`${window.subscriptionFlow.variantId}`;
   giftProperty['_gift_pair_id'] = giftPairId;
   giftProperty['_isGiftProduct']='true';
   if(window.subscriptionFlow.giftNote !== null && window.subscriptionFlow.giftNote.length>0){
    giftProperty['Note']= window.subscriptionFlow.giftNote;
   }

  if (window.subscriptionFlow.giftVariantId != null) {
    items.push( {
      quantity: 1,
      id: parseInt(window.subscriptionFlow.giftVariantId),
      properties : giftProperty
    });
  }
  
  if (typeof ttq !== 'undefined' && ttq && typeof ttq.track === 'function') {
    ttq.track('AddToCart',{  
      content_id: parseInt(window.subscriptionFlow.variantId),
      quantity: 1,
      value: window.subscriptionFlow.subTotal,
      currency: 'USD',})
  }
  
  let subscriptionData = {};
  if (window.globalVariables.first_crate_title != null) {
   
    subscriptionData['First Crate'] = window.globalVariables.first_crate_title;
  }
  subscriptionData['Shirt Size'] = window.subscriptionFlow.productSize;
  //subscriptionData['shipping_interval_pay_frequency'] = `${window.subscriptionFlow.payFrequency}`;
  subscriptionData['type_of_subscription'] = window.subscriptionFlow.frequency;
  //subscriptionData['shipping_interval_frequency'] = `${window.subscriptionFlow.shipFrequency}`;
  //subscriptionData['shipping_interval_unit_type'] = "month";
  //subscriptionData['subscription_id'] = `${window.subscriptionFlow.frequency}-${window.subscriptionFlow.payFrequency}month`;
  if (window.globalVariables.templateSuffix != "subscription-product" && window.globalVariables.templateSuffix != "subscription") {
    subscriptionData['Age'] = window.subscriptionFlow.age;
    subscriptionData['Position'] = window.subscriptionFlow.positon;
  }
  // subscriptionData['Age'] = window.subscriptionFlow.age;
  // subscriptionData['Position'] = window.subscriptionFlow.positon;
  //subscriptionData['black_friday_discount_amount'] = '0';
  subscriptionData['product_type'] = window.subscriptionFlow.productType;
  subscriptionData['is_subscrption'] = true; 
  subscriptionData['_gift_pair_id'] = giftPairId;
  // if ( window.subscriptionFlow.productType == 'platecrate' || window.globalVariables.templateSuffix == 'subscription-product') {
       if (specialCrate != null) {
        let currentVariant = specialCrate.find(variant => variant.title == window.subscriptionFlow.productSize);
        if (currentVariant) {
           subscriptionData['First Crate SKU'] = currentVariant.sku;
        }else{
           subscriptionData['First Crate SKU'] = window.subscriptionFlow.crateSKU;
        }
        // You can now use productHandle to fetch product data or update UI
      } else {
        subscriptionData['First Crate SKU'] = window.subscriptionFlow.crateSKU;
      }
  // }
  if ((window.subscriptionFlow?.productPropertyNote !== "" || window?.subscriptionFlow?.productPropertyNote?.length>0) && (window.subscriptionFlow.crateName === "THIS MONTH'S THEME" || window.subscriptionFlow.productType === "platecrate-pro")) {
    subscriptionData['Note'] = window.subscriptionFlow.productPropertyNote;
  }

  items.push({
    quantity: 1,
    id: parseInt(window.subscriptionFlow.variantId),
    properties: subscriptionData,
    selling_plan : window.subscriptionFlow.selling_plan_id
  });

  const body = JSON.stringify({
  items: items
  });

  fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: body
  })
  .then(async data => {
    // if ( window.subscriptionFlow.addToCartBtn) {
      if (window.subscriptionFlow.addToCartBtn) {
        window.subscriptionFlow.addToCartBtn.classList.remove('loading');
      }
    // }
      
       // if(window.globalVariables.templateSuffix === 'subscription-product'){

        // var ga_all = ga.getAll()[0].get('linkerParam');
        // var checkout_url = 'https://' + window.globalVariables.recharge_checkout_domain + '/r/checkout?',
        //       url_params = [
        //         'myshopify_domain=' + window.globalVariables.permanent_domain,
        //       ];
        //     url_params = url_params
        //       .concat('cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2])
        //       .concat(ga_all);
        //     var chk_url = checkout_url + url_params.join('&');
        // window.location.href = chk_url;
       // }else{
          // window.location.href = "/checkout";
       // }
       if (window.subscriptionFlow.discount_code != '') {
        let code = window.subscriptionFlow.discount_code
        let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/"
        window.location.href = discountApplyUrl;
      }else{
        window.location.href = "/checkout"
      }
  }).catch(e => {
    // if ( window.subscriptionFlow.addToCartBtn) {
      if (window.subscriptionFlow.addToCartBtn) {
        window.subscriptionFlow.addToCartBtn.classList.remove('loading');
      }
    // }
  });
   }

   async _clear_cart(event){

    const response_clear = await fetch(`/cart/clear.js`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      }
    })
    //  if(response_clear.ok){
    //   this._AddToCart(event);
    //  }
   }


  isAllDetailSelected(){
    if ( window.globalVariables.templateSuffix === "subscription"){
      this.setProCrateSKU()
    }
    const isSubscriptionTemplate = window.globalVariables.templateSuffix === "subscription";
    if( window.globalVariables.templateSuffix == "subscription-product" || window.globalVariables.templateSuffix === "subscription"){
      if (window.subscriptionFlow.productType == 'platecrate') {
        const isInvalid = (
            (!isSubscriptionTemplate && window.subscriptionFlow.crateSKU == null) ||
            window.subscriptionFlow.payFrequency == null ||
            window.subscriptionFlow.productType == null ||
            window.subscriptionFlow.productSize == null ||
            window.subscriptionFlow.variantId == null
        );

        document.querySelectorAll("[data-submit-subscription]").forEach(ele => {
          ele.classList.toggle("disabled", isInvalid);
        });
      }
      else if (window.subscriptionFlow.productType == 'platecrate-pro') {
        const isInvalid = (
            (!isSubscriptionTemplate && window.subscriptionFlow.crateSKU == null) || // apply crateSKU check here too
            window.subscriptionFlow.payFrequency == null ||
            window.subscriptionFlow.productType == null ||
            window.subscriptionFlow.productSize == null ||
            window.subscriptionFlow.variantId == null
        );

        document.querySelectorAll("[data-submit-subscription]").forEach(ele => {
          ele.classList.toggle("disabled", isInvalid);
        });
      }
      else{
        let mainProductData = null;
        document.querySelectorAll(".payfrequency-block-inner").forEach((subs)=>{
          let productType = subs.getAttribute("data-product-type")
          if(productType==="platecrate-lite"){
            const giftVariantId = subs.getAttribute("gift_variant_id")
            if(giftVariantId){
              window.subscriptionFlow.giftVariantId = giftVariantId;
            }
            mainProductData = JSON.parse(subs.querySelector("[data-main-product-variant]").innerText);
  
            // window.subscriptionFlow.selling_plan_id = parseInt(document.querySelector("[data-main-product-variant]")[0]["selling_plan_id"])
          }
        })
        if(  window.subscriptionFlow.productSize !== null){
          mainProductData = mainProductData.find(x=> x.variant_title == window.subscriptionFlow.productSize);
          window.subscriptionFlow.frequency = 1;
          document.querySelector("[data_crate_frequency]").textContent = 1;
        }
      }

    }else{
    if (window.subscriptionFlow.productType == 'platecrate') {
      if (window.subscriptionFlow.age == null || window.subscriptionFlow.crateSKU == null || window.subscriptionFlow.payFrequency == null||
          window.subscriptionFlow.positon  == null || window.subscriptionFlow.productType == null || window.subscriptionFlow.productSize == null ||
          window.subscriptionFlow.variantId == null) {
              document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
                ele.classList.add("disabled");
              })
      }else{
        document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
          ele.classList.remove("disabled");
        });
      }
    }
    else if(window.subscriptionFlow.productType == 'platecrate-pro'){
      if (window.subscriptionFlow.age == null  || window.subscriptionFlow.payFrequency == null||
        window.subscriptionFlow.positon  == null || window.subscriptionFlow.productType == null || window.subscriptionFlow.productSize == null ||
        window.subscriptionFlow.variantId == null) {
            document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
              ele.classList.add("disabled");
            })
      }else{
        document.querySelectorAll("[data-submit-subscription]").forEach(ele=>{
          ele.classList.remove("disabled");
        });
      }
    }else{
      let mainProductData = null;
      document.querySelectorAll(".payfrequency-block-inner").forEach((subs)=>{
        let productType = subs.getAttribute("data-product-type")
        if(productType==="platecrate-lite"){
          const giftVariantId = subs.getAttribute("gift_variant_id")
          if(giftVariantId){
            window.subscriptionFlow.giftVariantId = giftVariantId;
          }
          mainProductData = JSON.parse(subs.querySelector("[data-main-product-variant]").innerText);

          // window.subscriptionFlow.selling_plan_id = parseInt(document.querySelector("[data-main-product-variant]")[0]["selling_plan_id"])
        }
      })
      if(window.subscriptionFlow.age !== null && window.subscriptionFlow.positon  !== null &&  window.subscriptionFlow.productSize !== null){
        mainProductData = mainProductData.find(x=> x.variant_title == window.subscriptionFlow.productSize);
        window.subscriptionFlow.frequency = 1;
        document.querySelector("[data_crate_frequency]").textContent = 1;
      }
    }
  }
  }
   
}
new subscriptionFunnalCommon()
